import { ListenableSubscribable } from '@benzinga/subscribable';
import { deepEqual } from '@benzinga/utils';
import { Card } from './entities';

interface CardsUpdateEvent {
  cards: Card[] | undefined;
  type: 'shop:cards_update';
}

export type ShopStoreEvent = CardsUpdateEvent;

export class ShopStore extends ListenableSubscribable<ShopStoreEvent> {
  private date?: Date;
  private cards?: Card[];

  constructor() {
    super();
    this.date = undefined;
    this.cards = undefined;
  }

  public static compareCards = (lhs: Card[], rhs: Card[]): boolean => {
    return (
      lhs.length === rhs.length &&
      lhs?.every(card => {
        const newCard = rhs.find(newCard => card.uuid === newCard.uuid);
        if (newCard) {
          return deepEqual(card, newCard);
        } else {
          return false;
        }
      })
    );
  };

  public shouldWeFetchCard = (): boolean => {
    const ONE_MIN = 60 * 1000; /* ms */
    const lastCalled = this.date?.getTime() ?? 0; // use this once all Card are grabbed from manager
    if (this.cards === undefined || Date.now() - lastCalled > ONE_MIN) {
      return true;
    }
    return false;
  };

  public getCards = (): Card[] | undefined => {
    return this.cards;
  };

  // returns true if no update was needed;
  public updateCards = (cards: Card[]) => {
    if (this.cards && ShopStore.compareCards(this.cards, cards)) {
      this.date = new Date();
    } else {
      this.cards = cards;
      this.dispatch({
        cards: cards,
        type: 'shop:cards_update',
      });
    }
  };

  public clearCards = () => {
    this.cards = [];
    this.dispatch({
      cards: undefined,
      type: 'shop:cards_update',
    });
  };

  public addCard = (card: Card): void => {
    if (this.cards) {
      this.cards.push(card);
    } else {
      this.cards = [card];
    }
  };

  public updateCard = (card: Card): void => {
    this.cards?.map(item => (item.uuid === card.uuid ? card : item));
  };

  public removeCard = (card: Card): void => {
    this.cards?.filter(item => item.uuid !== card.uuid);
  };
}
